import { Component, OnInit } from '@angular/core';
import { HeaderBreadcrumbService } from '../../header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { Subscription } from 'rxjs/internal/Subscription';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/internal/operators/catchError';
import { CatalogsService } from 'src/app/services/catalogs-services/catalogs-services/catalogs.service';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { PreparationsService } from 'src/app/services/catalogs-services/preparations-services/preparations.service';
import { ProductsService } from 'src/app/services/catalogs-services/products-services/products.service';
import { empty } from 'rxjs';

@Component({
  selector: 'app-catalogs-dashboard',
  templateUrl: './catalogs-dashboard.component.html',
  styleUrls: ['./catalogs-dashboard.component.scss']
})
export class CatalogsDashboardComponent implements OnInit {

  catalogsCounts;
  preparationsCounts;
  productsCounts;
  getCatalogsCountsSubscription: Subscription;
  getPreparationsCountsSubscription: Subscription;
  getProductsCountsSubscription: Subscription;

  constructor(private headerBreadcrumbService: HeaderBreadcrumbService,
              private catalogsService: CatalogsService,
              private preparationsService: PreparationsService,
              private productsService: ProductsService,
              private snackbarService: SnackBarService) { }

  ngOnInit() {
    this.setBreadcrumb();
    this.getCatalogsCounts();
    this.getPreparationsCounts();
    this.getProductsCounts();
  }


  private getCatalogsCounts() {
    this.getCatalogsCountsSubscription = this.catalogsService.getCatalogsCounts().pipe(
      tap((o) => this.catalogsCounts = o),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return empty(); })
    ).subscribe();
  }

  private getPreparationsCounts() {
    this.getPreparationsCountsSubscription = this.preparationsService.getPreparationsCounts().pipe(
      tap((o) => this.preparationsCounts = o),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return empty(); })
    ).subscribe();
  }

  private getProductsCounts() {
    this.getProductsCountsSubscription = this.productsService.getProductsCounts().pipe(
      tap((o) => this.productsCounts = o),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return empty(); })
    ).subscribe();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-book-open', 'catalogs-page.catalog'));
  }
}
